module.exports = __webpack_public_path__ + "img/sao-tome-and-principe.2959a2d9.svg";